<template>
	<div class="avana-logo">
		<svg class="avana-logo__svg" id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 322.0795 69.179">
			<title>Avana Logo_R</title>

			<path
				class="cls-1"
				d="M40.292,0H28.0451L12.1874,39.1129c.63-.0218,1.2577-.046,1.8933-.046A50.2526,50.2526,0,0,1,25.2052,40.33L33.56,16.4528,48.206,57.1369c-1.1035-.2459-2.2639-.56-3.33-.8924a38.4472,38.4472,0,0,1-7.4947-3.243A49.7509,49.7509,0,0,0,22.706,47.5272a50.2564,50.2564,0,0,0-9.8695-.99c-1.2523-.0028-2.4883.0595-3.7189.146L0,69.1784H15.1437l4.0137-10.9757a38.7639,38.7639,0,0,1,12.7446,4.479A49.7191,49.7191,0,0,0,52.2928,68.989c.03.0028.0568.0081.0866.0081,1.35.1136,2.7128.1786,4.09.1813H67.6826Z"
			/>
			<path
				class="cls-1"
				d="M155.3862,0H143.1393L127.2816,39.1129c.63-.0218,1.2577-.046,1.8933-.046a50.2511,50.2511,0,0,1,11.1244,1.263l8.3548-23.8771L163.3,57.1369c-1.1036-.2459-2.2639-.56-3.33-.8924a38.45,38.45,0,0,1-7.4947-3.243A49.7774,49.7774,0,0,0,137.8,47.5272a50.2839,50.2839,0,0,0-9.8722-.99c-1.25-.0028-2.4857.0595-3.7163.146l-9.1175,22.4951h15.1436l4.0111-10.9757a38.7572,38.7572,0,0,1,12.7472,4.479,49.72,49.72,0,0,0,20.3908,6.3073c.0325.0028.0568.0081.0866.0081,1.35.1136,2.7128.1786,4.0895.1813h11.2137Z"
			/>
			<polygon class="cls-1" points="59.603 0 74 0 91.294 52.539 108.774 0 123.172 0 98.399 69.178 84.283 69.178 59.603 0" />
			<polygon
				class="cls-1"
				points="233.927 47.958 233.648 0.001 247.015 0.001 247.015 69.179 234.673 69.179 202.796 21.314 203.077 69.179 189.708 69.179 189.708 0.001 202.144 0.001 233.927 47.958"
			/>
			<path
				class="cls-1"
				d="M294.6889,0H282.442L266.5843,39.1129c.63-.0218,1.2576-.046,1.8933-.046a50.252,50.252,0,0,1,11.1245,1.263l8.3548-23.8771,14.646,40.6841c-1.1036-.2459-2.2639-.56-3.3295-.8924a38.4507,38.4507,0,0,1-7.4948-3.243,49.7774,49.7774,0,0,0-14.6757-5.4743,50.2831,50.2831,0,0,0-9.8722-.99c-1.25-.0028-2.4856.0595-3.7136.146l-9.12,22.4951h15.1437l4.011-10.9757a38.7577,38.7577,0,0,1,12.7473,4.479A49.7191,49.7191,0,0,0,306.69,68.989c.0324.0028.0568.0081.0866.0081,1.35.1136,2.7128.1786,4.0895.1813H322.08Z"
			/>
			<path
				class="cls-1"
				d="M312.1808,2.6481h-.7086V4.0247h.6194c.5112,0,.998-.1326.998-.733,0-.5545-.422-.6436-.9088-.6436m.9764,3.77a1.842,1.842,0,0,1-.1109-.5329L313,5.2661c-.065-.4-.1975-.7113-.6411-.7113h-.8871V6.4184h-.733V2.1178h1.6418c.7546,0,1.4632.1326,1.4632,1.063a.9872.9872,0,0,1-.7762,1.02c.5084.1326.6221.5113.6653.93l.0433.6655a1.3189,1.3189,0,0,0,.2.622Zm-.8655-5.542a3.4364,3.4364,0,1,0,3.4377,3.4351A3.4567,3.4567,0,0,0,312.2917.8764m0,7.6029a4.1909,4.1909,0,0,1-4.168-4.1678,4.168,4.168,0,1,1,4.168,4.1678"
			/>
		</svg>

		<span class="avana-logo__text">Wholesale</span>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.avana-logo {
	padding: 4px 0 0;
	font-size: 12px;
	display: flex;
	flex-direction: column;
	align-items: center;
	&__svg {
		height: 1.8em;
	}
	&__text {
		font-size: 1em;
		text-transform: uppercase;
		font-family: $brand-font-pro-bold;
		padding-top: 0.4em;
	}
}
</style>
